<script setup>
import ACTION_TYPES from '@/Common/Enum/ActionType.js';
import StatusIcon from '@/Pages/Common/StatusIcon.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { result } = defineProps({
  result: String,
  label: String
});

const type = (input) => {
  switch (input.toLowerCase()) {
    case 'pass':
      return ACTION_TYPES.NO_ACTION;
    case 'fail':
      return ACTION_TYPES.ACTION_REQUIRED;
    case 'softfail':
      return ACTION_TYPES.ACTION_RECOMMENDED;
    case 'none':
    case 'policy':
    case 'neutral':
      return ACTION_TYPES.INFO;
    case 'skipped':
    case 'temperror':
      return ACTION_TYPES.INFO_WARN;
    case 'permerror':
      return ACTION_TYPES.INFO_ERROR;
  }
};

const fmt = (input) => {
  switch (input.toLowerCase()) {
    case 'pass':
      return t('header_analysis.partials.auth_results_result.pass');
    case 'fail':
      return t('header_analysis.partials.auth_results_result.fail');
    case 'softfail':
      return t('header_analysis.partials.auth_results_result.softfail');
    case 'none':
      return t('header_analysis.partials.auth_results_result.none');
    case 'policy':
      return t('header_analysis.partials.auth_results_result.policy');
    case 'neutral':
      return t('header_analysis.partials.auth_results_result.neutral');
    case 'skipped':
      return t('header_analysis.partials.auth_results_result.skipped');
    case 'temperror':
      return t('header_analysis.partials.auth_results_result.temporary_error');
    case 'permerror':
      return t('header_analysis.partials.auth_results_result.permanent_error');
    default:
      return input;
  }
};
</script>

<template>
  <div class="flex items-center gap-1">
    <StatusIcon :action-type="type(result)" />
    {{ label ?? fmt(result) }}
  </div>
</template>
